"use client";

import { useEffect, useId } from "react";

const SheKnowsAd = ({ type, id: propId }) => {
  const reactId = useId();
  const myId = propId || `skm-ad-${type}-${reactId.replace(/:/g, "")}`;

  useEffect(() => {
    if (typeof window !== "undefined" && window.blogherads) {
      window.blogherads.adq.push([type, myId]);
    }
    return () => {
      if (
        typeof window !== "undefined" &&
        window.blogherads &&
        typeof window.blogherads.destroySlots === "function"
      ) {
        window.blogherads.destroySlots([myId]);
      }
    };
  }, [type, myId]);

  return <div id={myId}></div>;
};

export default SheKnowsAd;
